import { isBrowser } from 'utils/browser'

const CLIENT_PASSPHRASE = process.env.NEXT_PUBLIC_CRYPTO_JS_PASSPHRASE || ''
const SERVER_PASSPHRASE = process.env.CRYPTO_JS_PASSPHRASE || ''

export const PASSPHRASE = isBrowser ? CLIENT_PASSPHRASE : SERVER_PASSPHRASE
